<template>
    <div class="container-fluid">
        <!-- NAGŁÓWEK WIDOKU -->
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 px-3 px-md-0">
            <div>
                <h3 class="fw-bold mb-1">Ustawienia strony internetowej</h3>
                <p class="text-muted small mb-0">Zarządzanie wyglądem, nawigacją i kodami śledzącymi</p>
            </div>
        </div>

        <!-- PASEK ZAKŁADEK -->
        <ul class="nav nav-tabs custom-tabs mb-4 border-bottom" id="settingsTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'menu' }"
                    @click="activeTab = 'menu'"
                    type="button">
                    <i class="bi bi-list-task"></i>
                    <span>Zarządzanie menu</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'footer' }"
                    @click="activeTab = 'footer'"
                    type="button">
                    <i class="bi bi-layout-sidebar-reverse"></i>
                    <span>Stopka i dane kontaktowe</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'banner_meta' }"
                    @click="activeTab = 'banner_meta'"
                    type="button">
                    <i class="bi bi-tags"></i>
                    <span>Banner górny i meta tagi strony</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'template_colours' }"
                    @click="activeTab = 'template_colours'"
                    type="button">
                    <i class="bi bi-palette"></i>
                    <span>Kolorystyka i wybór szablonu</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'ownjs' }"
                    @click="activeTab = 'ownjs'"
                    type="button">
                    <i class="bi bi-code-square"></i>
                    <span>Wgraj własny kod śledzący</span>
                </button>
            </li>
        </ul>

        <!-- KARTA Z TREŚCIĄ ZAKŁADEK -->
        <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
                <form @submit.prevent="saveSettings">
                    <MenuTab v-if="activeTab === 'menu'" v-model="settings" />
                    <FooterTab v-if="activeTab === 'footer'" v-model="settings" />
                    <BannerMetaTab v-if="activeTab === 'banner_meta'" v-model="settings" />
                    <TemplateColoursTab v-if="activeTab === 'template_colours'" v-model="settings" />
                    <OwnJsTab v-if="activeTab === 'ownjs'" v-model="settings" />
                </form>
            </div>
        </div>
    </div>

    <!-- LOADER -->
    <div id="glownyloader">
        <AppLoader :show="loading || saving" :text="loaderText" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AppLoader from '@/components/AppLoader.vue'

// Importy komponentów zakładek
import MenuTab from '@/views/settings/MenuTab.vue'
import FooterTab from '@/views/settings/FooterTab.vue'
import BannerMetaTab from '@/views/settings/BannerMetaTab.vue'
import TemplateColoursTab from '@/views/settings/TemplateColoursTab.vue'
import OwnJsTab from '@/views/settings/OwnJsTab.vue'

const activeTab = ref('menu')
const loading = ref(false)
const saving = ref(false)
const loaderText = ref('')

const settings = ref({
    // Menu
    menuItems: [],
    
    // Stopka i dane kontaktowe
    companyName: '',
    address: '',
    contactEmail: '',
    contactPhone: '',
    footerText: '',
    socialLinks: {
        facebook: '',
        instagram: '',
        youtube: ''
    },

    // Banner górny i Meta Tagi
    topBannerEnabled: false,
    topBannerText: '',
    topBannerLink: '',
    metaTitle: '',
    metaDescription: '',
    metaKeywords: '',

    // Kolorystyka i szablon
    activeTemplate: 'default',
    primaryColor: '#0d6efd',
    secondaryColor: '#6c757d',
    accentColor: '#ffc107',

    // Własny kod śledzący
    headScript: '',
    bodyScript: ''
})

const loadSettings = async () => {
    
}

const saveSettings = async () => {
    
}

onMounted(() => {
    loadSettings()
})
</script>

<style scoped>
.custom-tabs .nav-link {
    color: var(--nav-link-color);
    font-weight: 500;
    border: none;
    border-bottom: 2px solid transparent;
    padding: 0.75rem 1.25rem;
    transition: all 0.2s ease;
}

.custom-tabs .nav-link:hover {
    color: var(--nav-link-hover-color);
    border-color: var(--nav-link-hover-border-color);
}

.custom-tabs .nav-link.active {
    color: var(--nav-link-active-color);
    border-bottom: 2px solid var(--nav-link-active-border-color);
    background-color: transparent;
    font-weight: 600;
}

.custom-tabs {
  display: flex !important;
  flex-wrap: nowrap !important; /* Blokuje łamanie do nowej linii */
  overflow-x: auto !important;   /* Włącza poziomy scroll */
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch; /* Płynne przewijanie na iOS */
  scrollbar-width: thin; /* Cienki scrollbar dla Firefox */
}

/* Opcjonalnie: ukrycie lub stylizacja paska przewijania */
.custom-tabs::-webkit-scrollbar {
  height: 4px;
}

.custom-tabs::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.custom-tabs .nav-item {
  flex: 0 0 auto; /* Zapobiega ściskaniu pojedynczych zakładek */
}
</style>